/*
*
* PAGE CATEGORIE JS
*
*/

window.initCarousel = require('../partials/global').initCarousel;

jQuery(document).ready(($) => {

  

  // if($('.categories-sections-wrapper').length > 0) {
  //   var beforeRule = CSSRulePlugin.getRule(".categories-sections-wrapper:before"); //get the rule
  //   var afterRule = CSSRulePlugin.getRule(".categories-sections-wrapper:after"); //get the rule
  //   console.log('beforeRule', beforeRule)

  //   var val_to_test = beforeRule.top.substr(0, beforeRule.top.length - 2);

  // $(document).on('scroll', function(e) {
  //   var scrolltop = $(window).scrollTop();
  //     // TweenMax.to(beforeRule, .1, {cssRule:{top: parseInt(val_to_test) + scrolltop + 100 }, ease: Circ.easeInOut});
  //     // TweenMax.to(afterRule, .1, {cssRule:{top: parseInt(val_to_test) + scrolltop + 100}, ease: Circ.easeInOut}, '+=1');

  //     TweenMax.to({}, 0.016, {
  //       repeat: -1,
  //       onRepeat: function() {
          
      
  //         TweenMax.set(beforeRule, {cssRule:{top: parseInt(val_to_test) + scrolltop + 200 }, ease: Circ.easeInOut});
      
  //         TweenMax.set(afterRule, {cssRule:{top: parseInt(val_to_test) + scrolltop -100}, ease: Circ.easeInOut}, '+=1');
  //       }
  //     });
  // })

  // }
 
   function setHeightForTrocVente() {
     var deck_vente = $('.card-deck-vente');
     var imgs_vente = deck_vente.find('.card-img-top');
    //  var overlay_vente = deck_vente.find('.card-img-overlay');

     imgs_vente.each((i, img) => {
       $(img).ready(function() {
        if($(window).width() < 992) {
          var height = $(img).outerHeight(true);
          $(img).next().css({'height': height+'px'})
         }
         else {
          $(img).next().css({'height': ''})
         }
       }) 
     })
   }

   setHeightForTrocVente();
  

  // initCarousel('.owl-carousel');
  var opts_for_selection_troc = {
    items:2,
    loop: true,
    center: false,
    stagePadding: 20
  }
  var default_opts_for_category_list = {
    stagePadding: 20
  }

  jQuery( window ).on('load', function() {

    if ($('.card-deck-default').length > 0) {
      //jQuery('.card-deck-default .card-header').matchHeight()
    }

  });

  initCarousel('.category-list', default_opts_for_category_list);
  initCarousel('.owl-other', opts_for_selection_troc);

  initReveal('.main-wrapper .section-heading, .troc-vous-facile-la-vie .section-heading', {
    delay: 200,
    useDelay: 'onload',
    interval: 150,
    reset: false,
    distance: '10px',
    origin: 'bottom',
    easing: 'ease'
  });

  initReveal('.secondary-title', {
    delay: 100,
    useDelay: 'onload',
    interval: 100,
    reset: false,
    distance: '10px',
    origin: 'bottom',
    easing: 'ease',
    viewOffset: {
        top: -100,
        right: 0,
        bottom: 0,
        left: 0,
    }
  });

  initReveal('.category-list .media, .card-deck-default .card, .card-deck-vente .card', {
    delay: 100,
    useDelay: 'onload',
    interval: 100,
    reset: false,
    distance: '20px',
    origin: 'bottom',
    easing: 'ease',
    viewOffset: {
        top: -100,
        right: -300,
        bottom: 0,
        left: 0,
    }
  });

  $(window).on('resize', () => {
    setHeightForTrocVente();
    initCarousel('.category-list');
    initCarousel('.owl-other', opts_for_selection_troc);
  });
});
